module.exports = __webpack_public_path__ + "static/media/berliner_morgenpost.6c9456d0.jpg";